<template>
  <ul
    class="sidebar-menu"
    v-if="authService.currentRole.nama_role === 'Admin Laksita' || authService.currentRole.nama_role === 'Admin Jembrana'"
  >
    <router-link
      to="/admin"
      tag="li"
    >
      <a
        class="nav-link"
        href="javasript.void(0)"
      ><i class="fas fa-home" /><span>Home</span></a>
    </router-link>
    <li class="menu-header">
      Layanan
    </li>
    <router-link
      to="/info-layanan"
      tag="li"
    >
      <a
        class="nav-link"
        href="javasript.void(0)"
      ><i class="far fa-list-alt" /><span>Layanan</span></a>
    </router-link>
    <li class="menu-header">
      Permohonan
    </li>
    <router-link
      to="/permohonan/data-permohonan"
      tag="li"
    >
      <a
        class="nav-link"
        href="javasript.void(0)"
      ><i class="far fa-list-alt" /><span>Data Permohonan</span></a>
    </router-link>
    <li class="menu-header">
      Laporan
    </li>
    <router-link
      to="/report/jumlah-permohonan"
      tag="li"
    >
      <a
        class="nav-link"
        href="javasript.void(0)"
      ><i class="fas fa-columns" /><span>Jumlah Permohonan</span></a>
    </router-link>
    <router-link
      to="/report/status-permohonan"
      tag="li"
    >
      <a
        class="nav-link"
        href="javasript.void(0)"
      ><i class="fas fa-columns" /><span>Status Permohonan</span></a>
    </router-link>
    <li class="menu-header">
      Kependudukan
    </li>
    <router-link
      to="/kependudukan/data-penduduk"
      tag="li"
    >
      <a
        class="nav-link"
        href="javasript.void(0)"
      ><i class="fas fa-users" /><span>Data Penduduk</span></a>
    </router-link>
    <router-link
      to="/kependudukan/akun-penduduk"
      tag="li"
    >
      <a
        class="nav-link"
        href="javasript.void(0)"
      ><i class="fas fa-user" /><span>Kelola Akun</span></a>
    </router-link>
    <router-link
      to="/kependudukan/generate-otp"
      tag="li"
    >
      <a
        class="nav-link"
        href="javasript.void(0)"
      ><i class="fas fa-user" /><span>Generate OTP</span></a>
    </router-link>
    <!-- <router-link
      to="/kependudukan/sinkronisasi"
      tag="li"
    >
      <a
        class="nav-link"
        href="javasript.void(0)"
      ><i class="fas fa-sync" /><span>Sinkronisasi Penduduk</span></a>
    </router-link> -->
    <li class="menu-header">
      Kelola Website
    </li>
    <router-link
      to="/admin/berita"
      tag="li"
    >
      <a
        class="nav-link"
        href="javasript.void(0)"
      ><i class="fas fa-list-alt" /><span>Berita</span></a>
    </router-link>
    <router-link
      to="/admin/page/kontak"
      tag="li"
    >
      <a
        class="nav-link"
        href="javasript.void(0)"
      ><i class="fas fa-list-alt" /><span>Kontak</span></a>
    </router-link>
    <router-link
      to="/log"
      tag="li"
    >
      <a
        class="nav-link"
        href="javasript.void(0)"
      ><i class="fas fa-list-alt" /><span>Log</span></a>
    </router-link>
    <!-- <li class="menu-header">Sistem (Admin Only)</li>
    <router-link to="/sistem/mapping-layanan-form-pendaftaran" tag="li">
      <a class="nav-link" href="javasript.void(0)"><i class="fas fa-list-alt"></i><span>Mapping Layanan-Form F1.02</span></a>
    </router-link> -->


    <!-- <li class="menu-header">Pengaturan</li>
    <router-link to="/admin/opsi-revisi" tag="li">
      <a class="nav-link" href="javasript.void(0)"><i class="fas fa-cog"></i><span>Pengaturan Aplikasi</span></a>
    </router-link> -->
  </ul>
</template>

<script>
export default {
	data() {
		return {

		}
	},
	computed: {
		authService(){
			return this.$store.getters.getAuthService
		}
	},
	created(){

	}
}
</script>